import { Reveal } from "./Reveal";
import PageHero from "./PageHero";
import { LEGAL_UPDATED, GALLERY } from "../data/content";

import Seo from "../components/Seo";

const SITE = "https://www.btkmortgages.co.uk";
const DEFAULT_IMAGE =
  "https://images.pexels.com/photos/39932417/pexels-photo-39932417.jpeg?auto=compress&cs=tinysrgb&w=1600";
const BRAND = "BTK Mortgage Services";

const LegalPage = ({ testId, eyebrow, title, italic, intro, image, sections, path, seoTitle, seoDescription }) => (
  <main data-testid={testId} className="bg-brand-bone">
    <Seo
      title={seoTitle || title.replace(/[.,]+$/, "")}
      description={seoDescription || intro}
      path={path}
      image={image}
    />
    <PageHero
      testId={`${testId}-hero`}
      eyebrow={eyebrow || "Legal"}
      title={title}
      italic={italic}
      intro={intro}
      image={image || GALLERY[7]}
    />
    <section className="mx-auto max-w-4xl px-5 py-20 sm:px-8 sm:py-28">
      <Reveal>
        <p className="text-[0.72rem] font-semibold uppercase tracking-[0.3em] text-neutral-500">
          Last updated: {LEGAL_UPDATED}
        </p>
      </Reveal>
      <div className="mt-14 space-y-14">
        {sections.map((s, i) => (
          <Reveal key={s.title} delay={Math.min(i * 0.05, 0.25)}>
            <section data-testid={`${testId}-section-${i + 1}`} className="border-l-2 border-brand/30 pl-6">
              <h2 className="editorial-h text-2xl text-brand-ink sm:text-3xl">{s.title}</h2>
              <div className="mt-5 space-y-4">
                {s.body.map((p, j) => (
                  <p key={j} className="text-sm leading-relaxed text-neutral-700 sm:text-base">
                    {p}
                  </p>
                ))}
              </div>
            </section>
          </Reveal>
        ))}
      </div>
    </section>
  </main>
);

export default LegalPage;
